/**
 * 俄语（ru-RU）
 */

import ruRULocale from 'element-ui/lib/locale/lang/ru-RU'
import publish from './publish/ru-Ru'
import personal from './personal/ru-Ru'
import order from './order/ru-Ru'
import customProduct from './customProduct/ru-Ru'
import index from './index/ru-Ru'
export default {
  ...ruRULocale,
  currency: {
    product: 'продукт',
    inStock: 'запасы',
    myProduct: 'Мой продукт',
    listings: 'перечень',
    wishList: 'список желаний',
    allOrder: 'Все нормально',
    store: 'магазин',
    personalCenter: 'персональный центр',
    payment: 'платить',
    address: 'адрес',
    accountSettings: 'Настройки учётной записи',
    logOut: 'Списание',
    cancel: 'отмена',
    submit: 'представление',
    selectAll: 'полное обогащение',
    confirmOrder: 'подтверждать заказ',
    back: 'назад',
    home: 'жилище',
    newIn: 'новый',
    deleteTip: 'Удалить выбранный продукт?',
    delete: 'Исключить'
  },
  // 语言
  lang: {
    english: 'английский',
    chinese: 'китайский язык',
    spanish: 'испанский',
    japanese: 'японец',
    portuguese: 'португальский язык',
    french: 'французский язык',
    russian: 'русский язык',
    arabic: 'арабский язык',
    german: 'немецкий',
    italian: 'итальянец',
    vietnam: 'Вьетнам',
    turkey: 'Турция',
    korean: 'кореец',
    thai: 'таиландец',
    dutch: 'голландский язык',
    hebrew: 'иврит',
    indonesian: 'индонезийский язык'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'Категория',
    search: 'поиск',
    searchingFor: 'Разделённый запятыми или пробелами',
    shippingFrom: 'Доставка из',
    fabric: 'Ткань',
    price: 'Цена',
    inventory: 'Инвентарь',
    newest: 'Новейшие',
    sales: 'Продажи',
    min: 'печалиться',
    max: 'максимум',
    recentSearches: 'Последний поиск',
    hotSearches: 'поиск'
  },
  // 商品详情页
  productDetail: {
    product: 'продукт',
    detail: 'подробности',
    itemNo: 'нумерация пунктов',
    processingTime: 'время обработки',
    shippingCost: 'фрахт',
    paymentMethod: 'форма платежа',
    sizeGuide: 'таблица размеров',
    color: 'цвет',
    size: 'размер',
    viewAllVariants: 'все варианты',
    allVariants: 'все варианты',
    shipFrom: 'следовать',
    addToCart: 'Добавить в торговый автомобиль',
    listToStore: 'Сохранить список',
    addToWishList: 'Добавить в список пожеланий',
    description: 'описание',
    return: 'возвращение',
    refundPolicy: 'политика возмещения расходов',
    shipping: 'судоходство',
    image: 'образ',
    action: 'Меры',
    // 选项卡/shipping
    packingSize: 'размер упаковки',
    packingWeight: 'вес упаковки',
    shippingFrom: 'следовать',
    shippingTo: 'доставлять',
    qty: 'количество',
    maximum: 'Максимальные запасы:',
    shippingMethod: 'вид транспорта',
    estimatedDeliveryTime: 'предполагаемое время поставки',
    sizeChart: 'таблица размеров',
    deliveryTime: 'срок поставки',
    outOfStockTips: 'Извините, товар пропал!',
    pleaseSelected: 'Выберите ',
    customerReviews: 'Комментарий клиента',
    writeAReview: 'написать комментарий'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: 'торговый автомобиль',
    topTip: 'Выберите товар на том же складе.'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'адрес доставки',
    addNewAddress: 'Добавить новый адрес',
    selectAnotherAddress: 'Выбрать другой адрес',
    editTheAddress: 'изменить адрес',
    remark: 'Замечания',
    unitPrice: 'единичная цена',
    totalPayable: 'Общая сумма кредиторской задолженности',
    itemSubtotal: 'Итого проекта',
    subtotal: 'Итого по разделу',
    shippingSubtotal: 'судовой баланс',
    promotion: 'Повышение в должности',
    grandTotal: 'итого',
    creditCard: 'кредитная карточка',
    balance: 'равновесие',
    payNow: 'платить сейчас',
    commonProblem: 'Общие вопросы',
    emailVerification: 'проверка электронной почты',
    verificationTitle: 'код проверки отправлен по',
    verification: 'проверка',
    seconds: 'секунда',
    laterGetPasswordAgain: 'получить пароль позже',
    sendAgain: 'пересылать'
  },
  // 账号设置弹窗
  setting: {
    setting: 'фон',
    fullName: 'полное имя',
    email: 'электронная почта',
    password: 'пароль',
    confirmPassword: 'подтвердить пароль',
    notVerified: 'Не проверено',
    change: 'Изменить',
    codeSend: 'код проверки отправлен по'
  },
  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index
}
